/**
 * @file: 常用号码详情页
 * @author: wence
 */
import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import classname from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {getNumberCommonList, getNumberCommonInfo} from '../../actions/numberAuthAction';
import './index.less';

export class NumberCommon extends PureComponent {
    static propTypes = {
        getNumberCommonList: PropType.func,
        getNumberCommonInfo: PropType.func,
        numberCommonInfo: PropType.array,
        numberCommonList: PropType.array,
        match: PropType.object
    }
    constructor(props) {
        super(props);

        this.state = {
            activeIndex: 0,
            isShowDrapdown: false,
            openDetailsIndexs: [],
            fixed: false
        };

        this.tabItemLefts = [];

        this.setSrollLeft = this.setSrollLeft.bind(this);
        this.fetchDetail = this.fetchDetail.bind(this);

        if (this.isPC()) {
            const id = this.props.match.params.id;
            location.href = id ? '/haoma/common?id=' + id : '/haoma/common';
        }
    }

    async componentDidMount() {
        const id = this.props.match.params.id;
        await this.props.getNumberCommonList();

        const list = this.props.numberCommonList || [];
        const curListIds = list.map(item => item.id);
        const index = curListIds.indexOf(id) || 0;

        await this.fetchDetail(list, index);

        this.setState({activeIndex: index});
        this.setSrollLeft(index);

        setTimeout(() => {
            this.setState({fixed: true});
        }, 100);
    }

    componentWillUnmount() {
        this.setState({fixed: false});
    }

    async fetchDetail(list, index) {
        const curId = (list[index] || list[0] || {}).id;
        await this.props.getNumberCommonInfo(curId);
        // 修复某些浏览器tab不显示问题
        if (this.isMount) {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
        }
        this.isMount = true;
    }

    setSrollLeft(index) {
        this.tab.scrollLeft = this.tabItemLefts[index - 2] || 0;
    }

    onChangeId(activeIndex) {
        this.setState({activeIndex, openDetailsIndexs: []});

        this.fetchDetail(this.props.numberCommonList, activeIndex);
    }

    onChangeDrapdownId(activeIndex) {
        this.setSrollLeft(activeIndex);
        this.setState({activeIndex, isShowDrapdown: false, openDetailsIndexs: []});

        this.fetchDetail(this.props.numberCommonList, activeIndex);
    }

    openDetails(openIndex, disabled) {
        if (disabled) {
            return;
        }

        const curOpenIndex = [].concat(this.state.openDetailsIndexs);
        const index = curOpenIndex.indexOf(openIndex);

        if (index >= 0) {
            curOpenIndex.splice(index, 1);
        }
        else {
            curOpenIndex.push(openIndex);
        }

        this.setState({openDetailsIndexs: curOpenIndex});
    }

    getName(item) {
        const details = item && item.details || [];
        if (!item.urldesc
            && !item.strip_url
            && details.length === 1
            && details[0]
            && details[0].number) {
            return item.name + '-' + (details[0] && details[0].number);
        }

        return item.name;
    }

    render() {
        const list = this.props.numberCommonList || [];
        const content = this.props.numberCommonInfo || [];
        const contentItem = content[0];

        return (
            <div className="number-common">
                <div className="number-common-content">
                    {!!contentItem
                        && !!contentItem.dial
                        && contentItem.dial.length > 0
                        && contentItem.dial.map((item, index) => {
                            const hasOpened = this.state.openDetailsIndexs.indexOf(index) >= 0;
                            const details = item && item.details || [];
                            const length = (item.urldesc && item.strip_url) ? details.length + 1 : details.length;
                            return (
                                <div
                                    key={index}
                                    className={classname('item-wrapper', {active: hasOpened})}>
                                    <div
                                        onClick={this.openDetails.bind(
                                            this,
                                            index,
                                            details.length <= 1 && !item.urldesc && !item.strip_url)}
                                        className="number-common-content-item">
                                        <img
                                            src={item.iconurl}
                                            alt="icon" />
                                        {this.getName(item)}
                                        {length > 1
                                            && <img
                                                className="arrow" alt="icon"
                                                src={require('../../asset/svg/icon_unfold_wap.svg')} />}
                                    </div>

                                    {length > 1
                                        && <div
                                            className="number-common-content-detail">
                                            {item.details.map((detailsItem, index) => {
                                                if (detailsItem.label && detailsItem.number) {
                                                    return <p key={index}>
                                                        {`${detailsItem.label}-${detailsItem.number}`}
                                                    </p>;
                                                }
                                                if (detailsItem.label) {
                                                    return <p key={index}>{detailsItem.label}</p>;
                                                }

                                                if (detailsItem.number) {
                                                    return <p key={index}>{detailsItem.number}</p>;
                                                }

                                                return null;
                                            })}
                                            {item.urldesc
                                                && item.strip_url
                                                && <p>
                                                    {item.urldesc + '-'}
                                                    <a className="detail-des"
                                                        target="_blank"
                                                        href={item.url}>{item.strip_url}</a>
                                                </p>}
                                        </div>}
                                </div>
                            );
                        })}
                </div>

                <div className={classname('number-common-tab', {fixed: this.state.fixed})}>
                    <div ref={tab => this.tab = tab} className="number-common-tab-container">
                        <ul>
                            {list.map((item, index) => {
                                return (
                                    <li
                                        ref={tabItem => {
                                            if (tabItem) {
                                                this.tabItemLefts[index] = tabItem.offsetLeft;
                                            }
                                        }}
                                        key={item.id}
                                        onClick={this.onChangeId.bind(this, index)}
                                        className={classname('number-common-tab-item',
                                            {active: this.state.activeIndex === index})}>
                                        {item.name}</li>
                                );
                            })}
                        </ul>
                    </div>
                    {(list.length - 1) !== this.state.activeIndex && <div className="shadow"></div>}
                    <div onClick={() => this.setState({isShowDrapdown: true})} className="number-common-tab-folder-btn">
                        <img
                            src={require('../../asset/svg/icon_changyonghaoma.svg')}
                            alt="number" />
                    </div>
                </div>

                {this.state.isShowDrapdown && <div className="drapdown">
                    <div className="mask"
                        onClick={() => this.setState({isShowDrapdown: false})}></div>
                    <ul className="drapdown-content">
                        {list.map((item, index) =>
                            <li
                                className={classname({active: this.state.activeIndex === index})}
                                key={item.id}
                                onClick={this.onChangeDrapdownId.bind(this, index)}>{item.name}</li>)}
                    </ul>
                </div>}
            </div>
        );
    }
}


export default connect(
    state => {
        return ({
            numberCommonList: state.numberCommonList,
            numberCommonInfo: state.numberCommonInfo
        });
    },
    dispatch => bindActionCreators({getNumberCommonList, getNumberCommonInfo}, dispatch)
)(NumberCommon);



// WEBPACK FOOTER //
// ./src/containers/numberCommon/index.js